module.exports = __webpack_public_path__ + "static/img/huawei-book.bda34fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/huawei-book.png
// module id = 7tEU
// module chunks = 2